import { EventCategory } from '@lendi/analytics-web';

import { FIELD_VALUES } from '@funnels/constants';

import { lendiAnalytics } from './analytics';
import { eventTracking } from './base';
// NEW_APPLICATION event
const NEW_APPLICATION = 'New Application Created';

interface NewApplicationEvent {
  event_name: typeof NEW_APPLICATION;
  category: EventCategory;
  primaryPurpose: FIELD_VALUES.REFINANCE | FIELD_VALUES.NEW_PURCHASE;
  applicationId: string;
}

export function newApplicationEventTracking(
  analytics: ReturnType<typeof lendiAnalytics>,
  applicationId: string,
  primaryPurpose: FIELD_VALUES.REFINANCE | FIELD_VALUES.NEW_PURCHASE
) {
  eventTracking<NewApplicationEvent>(analytics, {
    event_name: NEW_APPLICATION,
    category: EventCategory.FUNNELS,
    applicationId,
    primaryPurpose,
  });
}
